import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import InputAdornment from "@mui/material/InputAdornment";
import List from "@mui/material/List";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import { assertArray } from "core/validation";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AtsTooltip from "../AtsTooltip";
import { ContactListItem, filterContact, mapContact, sortList } from "./index";

const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
        padding: "10px",
        paddingRight: 0,
    },
    rootList: {
        width: "100%",
        maxHeight: 220,
        minHeight: 100,
        overflowY: "auto",
    },
}));

export default function ContactList({ contacts, listStyle, onSelectionChange, selectedContacts }) {
    const [searchValue, setSearchValue] = useState();
    const [options, setOptions] = useState(sortList(contacts));
    const propSelectedIds = assertArray(selectedContacts) ? selectedContacts.map((c) => c.id) : [];

    const [selectedIds, setSelectedIds] = useState(propSelectedIds);

    const classes = useStyles();

    useEffect(() => {
        setOptions(sortList(contacts));
        setSearchValue(null);
    }, [contacts]);

    useEffect(() => {
        if (selectedContacts.length > 0 && selectedContacts.length !== selectedIds.length) {
            const lastContact = selectedContacts[selectedContacts.length - 1];
            const user = mapContact(lastContact);
            showToastInfo(user.name, true);
        }
        setSelectedIds(propSelectedIds);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contacts.length]);

    useEffect(() => {
        if (selectedContacts.length !== selectedIds.length) {
            setSelectedIds(propSelectedIds);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedContacts.length]);

    function handleOnSearch(e) {
        const value = e.target.value;
        setSearchValue(value);
        setOptions(filterContact(sortList(contacts), value));
    }

    function showToastInfo(name, added) {
        const action = added ? "added to" : "removed from";
        const message = `${name} has been ${action} CC Recipients`;
        toast.info(message);
    }

    function toggleSelectAll() {
        if (contacts.length === selectedIds.length) {
            setSelectedIds([]);
        } else {
            setSelectedIds(contacts.map((c) => c.id));
        }
    }
    function handleOnChecked(checked, contactId) {
        const index = selectedIds.findIndex((id) => id === contactId);

        let ids = [];
        if (checked && index === -1) {
            ids = [...selectedIds, contactId];
            setSelectedIds(ids);
        } else if (!checked && index !== -1) {
            ids = selectedIds.filter((_, i) => i !== index);
            setSelectedIds(ids);
        }
        const _selectedContacts = contacts.filter((c) => ids.indexOf(c.id) >= 0);
        onSelectionChange(_selectedContacts);
    }

    const _listStyle = listStyle || {};
    const chip = selectedIds.length > 0 ? <Chip color="primary" size={"small"} label={selectedIds.length} /> : null;
    const btnLabel = selectedIds.length === options.length ? "Deselect All" : "Select all";
    const contactsTooltip = selectedContacts.map((c, i) => {
        const user = mapContact(c);
        let label = null;
        if (user.email) {
            label = `${i + 1} - ${user.name} <${user.email}>`;
        } else {
            label = `${i + 1} - ${user.name}`;
        }
        return (
            <div key={label}>
                {label}
                <br />
            </div>
        );
    });
    const tooltip = chip ? <AtsTooltip trigger={chip} content={contactsTooltip} /> : null;
    return (
        <Paper className={classes.root}>
            <div style={{ paddingRight: 10 }}>
                <TextField
                    size={"small"}
                    style={{ width: "calc(100% - 120px)" }}
                    variant={"outlined"}
                    value={searchValue}
                    onChange={handleOnSearch}
                    slotProps={{
                        input: {
                            endAdornment: <InputAdornment position="end">{tooltip}</InputAdornment>,
                        }
                    }}
                />
                <Button variant={"outlined"} size={"small"} style={{ marginLeft: 5 }} onClick={toggleSelectAll}>
                    {btnLabel}
                </Button>
            </div>
            <List style={_listStyle} className={classes.rootList}>
                {options.map((contact) => {
                    const isChecked = selectedIds.includes(contact.id);
                    return (
                        <ContactItemChecked
                            key={contact.id}
                            onChecked={handleOnChecked}
                            contact={contact}
                            isChecked={isChecked}
                        />
                    );
                })}
            </List>
        </Paper>
    );
}

function ContactItemChecked({ contact, onChecked, isChecked }) {
    const [checked, setChecked] = useState(isChecked);

    useEffect(() => {
        if (isChecked !== checked) {
            setChecked(isChecked);
        }
    }, [checked, isChecked]);

    function handleOnCheck(checked) {
        setChecked(checked);
        onChecked(checked, contact.id);
    }
    return (
        <ContactListItem
            key={contact.id}
            onChecked={handleOnCheck}
            showCheckboxes
            checked={checked}
            user={contact}
            showEmailFirst
        />
    );
}
